<template>
  <zord-card is-padded>
    <header>
      <zord-heading :level="1" :text="t('questions.form.header')" />
      <p>{{ t('questions.form.recent_results.subheader')}}</p>
    </header>

    <section>
      <zord-heading :level="4" :text="t('questions.form.recent_results.header')" />
      <div class="recent-results">
        <zord-card v-for="result in results"
          :key="result.order_number"
          @click="onResultSelection"
          :data-id="result.order_number"
          is-interactive
        >
          <article class="result">
            <zord-details
              :description="t('questions.form.recent_results.tests')"
              :value="result.tests"
            />
            <zord-details
              :description="t('questions.form.recent_results.order_number')"
              :value="result.order_number"
            />
            <zord-details
              :description="t('questions.form.recent_results.order_date')"
              :value="formatDate(result.order_date)"
            />
          </article>
        </zord-card>
        <zord-button
          :label="t('questions.form.recent_results.not_related')"
          @click="onResultSelection"
        />
      </div>
    </section>
  </zord-card>
</template>

<script>
import { t } from '@/javascripts/config/i18n'
import {
  ZordButton,
  ZordCard,
  ZordDetails,
  ZordHeading
} from '@/javascripts/components/zord'

export default {
  name: 'RecentResults',
  data() {
    return {
      t
    }
  },
  props: {
    results: {
      type: Array,
      default: []
    }
  },
  components: {
    ZordButton,
    ZordCard,
    ZordDetails,
    ZordHeading
  },
  methods: {
    onResultSelection({ currentTarget }) {
      const { id } = currentTarget.dataset
      const selectedResult = this.results.find(result => result.order_number === id)

      this.$parent.setSelectedResult(selectedResult || 'not_related')
    },
    formatDate(date) {
      const dateOptions = { month: '2-digit', day: '2-digit', year: 'numeric' }
      const dateObj = new Date(date)

      return dateObj.toLocaleDateString('en', dateOptions)
    }
  }
}
</script>

<style lang="scss" scoped>
  header {
    margin-bottom: var(--spacing-xl);
  }

  .recent-results {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }
</style>
